import { useTranslation } from 'react-i18next';
import { card, cardBody, REG_FONTS, flagBar } from './styles';
import type { Via } from './questions';

interface ViaSelectorProps {
  onSelect: (via: Via) => void;
}

export function ViaSelector({ onSelect }: ViaSelectorProps) {
  const { t } = useTranslation('regularizacion');

  return (
    <div className={card}>
      {flagBar}
      <div className={cardBody}>
        <h2
          className="text-xl font-bold text-[#1a1a1a] mb-5"
          style={{ fontFamily: REG_FONTS.heading }}
        >
          {t('via.title')}
        </h2>

        <div className="flex gap-4 max-sm:flex-col">
          <button
            onClick={() => onSelect('dt5')}
            className="flex-1 min-w-[200px] border-2 border-[#e0e0e0] rounded-2xl p-5 text-left hover:border-[#2e7d32] hover:bg-[#f1f8e9] transition-all duration-200 cursor-pointer"
          >
            <p className="font-bold text-[#1a1a1a] mb-1" style={{ fontFamily: REG_FONTS.body }}>
              {t('via.dt5_title')}
            </p>
            <p className="text-sm text-[#666]" style={{ fontFamily: REG_FONTS.body }}>
              {t('via.dt5_desc')}
            </p>
          </button>

          <button
            onClick={() => onSelect('dt6')}
            className="flex-1 min-w-[200px] border-2 border-[#e0e0e0] rounded-2xl p-5 text-left hover:border-[#2e7d32] hover:bg-[#f1f8e9] transition-all duration-200 cursor-pointer"
          >
            <p className="font-bold text-[#1a1a1a] mb-1" style={{ fontFamily: REG_FONTS.body }}>
              {t('via.dt6_title')}
            </p>
            <p className="text-sm text-[#666]" style={{ fontFamily: REG_FONTS.body }}>
              {t('via.dt6_desc')}
            </p>
          </button>
        </div>
      </div>
    </div>
  );
}
